import React from 'react';
import { Fingerprint, ScanFace, ArrowRight } from 'lucide-react';
import { SyncStatusBadge } from './SyncStatusBadge';
interface AttendanceRecord {
  id: string;
  employeeName: string;
  timeIn: string;
  timeOut?: string;
  method: 'fingerprint' | 'face';
  syncStatus: 'synced' | 'pending' | 'error';
}
interface AttendanceLogItemProps {
  record: AttendanceRecord;
}
export function AttendanceLogItem({
  record
}: AttendanceLogItemProps) {
  return <div className="bg-slate-800 rounded-xl p-4 border border-slate-700 flex items-center justify-between" data-id="element-8">
      <div className="flex items-center space-x-3" data-id="element-9">
        <div className="p-2 bg-slate-700/50 rounded-lg text-blue-400" data-id="element-10">
          {record.method === 'fingerprint' ? <Fingerprint size={20} data-id="element-11" /> : <ScanFace size={20} data-id="element-12" />}
        </div>
        <div data-id="element-13">
          <h4 className="text-white font-medium text-sm" data-id="element-14">
            {record.employeeName}
          </h4>
          <div className="flex items-center space-x-2 text-xs text-slate-400 mt-0.5" data-id="element-15">
            <span className="text-green-400 font-mono" data-id="element-16">{record.timeIn}</span>
            {record.timeOut && <>
                <ArrowRight size={10} data-id="element-17" />
                <span className="text-orange-400 font-mono" data-id="element-18">
                  {record.timeOut}
                </span>
              </>}
          </div>
        </div>
      </div>

      <SyncStatusBadge status={record.syncStatus} data-id="element-19" />
    </div>;
}